<div class="chart-editor">
  <div class="chart-row-header">
    <strong>{{chart.name || 'New chart'}}</strong>
    <span class="key-badge" *ngIf="chart.key">{{chart.key}}</span>
    <div class="spacer"></div>
    <button class="button small" [disabled]="index === 0" (click)="moveUp.emit()">&uarr;</button>
    <button class="button small" [disabled]="index >= count - 1" (click)="moveDown.emit()">&darr;</button>
    <button class="button small red" (click)="remove.emit()">Remove</button>
  </div>

  <div class="form-grid">
    <label>
      Name
      <input type="text" placeholder="e.g. Daily Sales" [(ngModel)]="chart.name" (ngModelChange)="nameChanged()" />
    </label>
    <label>
      Key
      <input type="text" placeholder="auto from name" [(ngModel)]="chart.key" (ngModelChange)="keyChanged()" />
    </label>
    <label>
      Type
      <select [(ngModel)]="chart.type">
        <option *ngFor="let t of chartTypes" [value]="t.key">{{t.name}}</option>
      </select>
    </label>
    <label>
      X Axis
      <select [(ngModel)]="chart.xPath">
        <option value="">(choose a field)</option>
        <option *ngFor="let f of xFields" [value]="f.path">{{f.name || f.path}} ({{f.type}})</option>
      </select>
    </label>
    <label *ngIf="xIsDate">
      Group X by
      <select [(ngModel)]="chart.xBucket">
        <option *ngFor="let b of buckets" [value]="b.key">{{b.name}}</option>
      </select>
    </label>
    <label>
      Series (optional)
      <select [(ngModel)]="chart.seriesPath">
        <option value="">(none — combine rows)</option>
        <option *ngFor="let f of seriesFields" [value]="f.path">{{f.name || f.path}}</option>
      </select>
    </label>
    <label>
      Combine rows by
      <select [(ngModel)]="chart.aggregate">
        <option *ngFor="let a of aggregates" [value]="a.key">{{a.name}}</option>
      </select>
    </label>
  </div>

  <div class="y-fields">
    <div class="y-title">Default Y fields <span class="hint">(viewers can toggle any numeric field)</span></div>
    <p class="hint" *ngIf="yFields.length === 0">Add a number or currency field to the report first.</p>
    <label class="flag" *ngFor="let f of yFields">
      <input type="checkbox" [checked]="isDefaultY(f.path)" (change)="toggleDefaultY(f.path, $event.target.checked)" />
      {{f.name || f.path}}
    </label>
  </div>
</div>
